<template>
  <div class="pb-[10] bg-[#f7f7f9]">
    <dg-head></dg-head>
    <div class="w-[1200] mt-[16] pb-[100] rounded-[4] mb-[20] px-[170] mx-[auto] shadow bg-[#fff]">

        <div class="text-center">
          <p class="t-[18] leading-[80] border-b-[1] border-[#ebeef5] border-solid">{{ title }}</p>
        </div>
        <div class="mt-[20]">
          <div class="" v-html="content"></div>
        </div>

    </div>
    <dg-copyright></dg-copyright>
  </div>
</template>
<script>
import mixin from "@/assets/js/mixin";

export default {
  mixins: [mixin],
  data() {
    return {
      content: "",
      protocolTypeName: "",
      title: "",
      protocolList: [],
    };
  },

  methods: {
    /**
     * @author 伟健 / 张
     * @name 获取协议
     */
    getUserProtocol() {
      if (!this.$route.query.id) return;
      ajax.post({
        url: "/supplyChain/auth/getProtocolDetail",
        data: { id: this.$route.query.id },
        success: (res) => {
          if (res) {
            this.content = res.content;
            this.title = res.title;
          }
        },
        fail: () => {},
      });
    },
  },
  created() {
    this.getUserProtocol();
  },
};
</script>

<style lang="less" scoped>
@import "~@/assets/css/var.less";
.shadow {
  box-shadow: 0 2px 10px 0 rgba(45, 72, 97, 0.1);
}
</style>
 <style>.pb-\[10\] {
    padding-bottom: 10px
}
.bg-\[\#f7f7f9\] {
    background-color: #f7f7f9
}
.w-\[1200\] {
    width: 1200px
}
.mt-\[16\] {
    margin-top: 16px
}
.pb-\[100\] {
    padding-bottom: 100px
}
.rounded-\[4\] {
    border-radius: 4px
}
.mb-\[20\] {
    margin-bottom: 20px
}
.px-\[170\] {
    padding-left: 170px;
    padding-right: 170px
}
.mx-\[auto\] {
    margin-left: auto;
    margin-right: auto
}
.bg-\[\#fff\] {
    background-color: #fff
}
.t-\[18\] {
    font-size: 18px
}
.leading-\[80\] {
    line-height: 80px
}
.border-b-\[1\] {
    border-bottom-width: 1px
}
.border-\[\#ebeef5\] {
    border-color: #ebeef5
}
.mt-\[20\] {
    margin-top: 20px
}
.text-center {
    text-align: center
}
.border-solid {
    border-style: solid
}</style>